import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from "vue";
import Layout from "@/pages/Layout/index.vue";
import GlobalServices from "./services/global";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    onMounted(function () {
      function applyLayout() {
        var width = window.innerWidth;

        if (width >= 1024) {
          // 桌面端样式
          GlobalServices.state.clientType = "PC";
        } else {
          // 移动端样式
          GlobalServices.state.clientType = "Mobile";
        }

        console.log(window.deviceType);
      }

      applyLayout(); // 监听窗口大小变化事件

      window.addEventListener("resize", applyLayout);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Layout);
    };
  }
});